module.exports = __webpack_public_path__ + "static/media/pgd.cc0e235e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/pgd.svg
// module id = 970
// module chunks = 0